module.exports = __webpack_public_path__ + "static/media/cal-ring.11611b7e.jpg";